/**
 * The viewer's top bar on a phone-sized screen (below md): the info button
 * (InfoContent) on the left and the action buttons (DialogActions) on the
 * right are two layers over the photo, and these sizes keep their icons on
 * one line. Every button is a 24px glyph with 8px around it, and the bar is
 * a button plus an inset above and below, with the buttons centred in it.
 */

/** Side of a button on the bar: a 24px glyph with 8px around it. */
export const PHONE_BAR_BUTTON = 40;

/** Space between the bar's buttons and its edges. */
export const PHONE_BAR_INSET = 4;

/** Height of the bar. */
export const PHONE_BAR_HEIGHT = PHONE_BAR_BUTTON + 2 * PHONE_BAR_INSET;

/**
 * Room the action buttons leave on the bar's left for the info button (the
 * button and an inset on each side of it), so a long row never runs under
 * it. Kept small: the fullest row, a floorplan button, the pencil, three
 * reactions, the download, "who viewed" and fullscreen, is 320px, and fits
 * beside it on a 375px phone.
 */
export const PHONE_BAR_INFO_ROOM = PHONE_BAR_BUTTON + 2 * PHONE_BAR_INSET;
